/*
 * @Description :
 * @Author      : pishengjun
 * @Date        : 2024-12-05 16:31:58
 */
import { RequestEnum, ServiceGateWay } from "@/utils/enum";
import httpRequest from "@/utils/request";
import type {
  CheckFaceFeatureParams,
  CompleteRealNameAuthenticationParams,
  CompleteRealNameAuthenticationResult,
  CompleteRealNameFaceImageParams,
  LoginParams,
  LoginResult,
  LoginStepSecondParams,
  RealNameAuthenticationParams,
  RegisterUserParams,
  SendPhoneCodeParams,
} from "../interfaceModel/ZhuoFan_Wb_RegisteredUserService_WebApi";
import type { CurrentRegisterUserModel, GetFaceFeatureUrlParams, RandomVerificationCodeMd5, RealNameAuthenticationResponse } from "../interfaceModel/FaceRecognitionService";
import type { LoginRegistrationSetting } from "../interfaceModel/LoginRegistrationSettingService";
import { store } from "@/store";

export class FaceRecognitionServiceClass {
  private static _baseUrl = ServiceGateWay.ZhuoFan_Wb_OAuthService_WebApi + "/api";

  /**
   * 获取系统设置信息
   * @returns {Promise<LoginRegistrationSetting>} 返回一个Promise，解析为SystemSetting类型的数据
   */
  static async getLoginRegistrationSetting() {
    const loginRegistrationSetting = await httpRequest<LoginRegistrationSetting>({
      url: `${this._baseUrl}/ExamineeLoginRegistrationSettingService/SystemSetting`,
      method: RequestEnum.GET,
      options: { token: "" },
    });
    store.commit("SET_DATA", { name: "loginRegistrationSetting", data: loginRegistrationSetting });
    return loginRegistrationSetting;
  }

  // 登陆第一步验证，用户名和密码 如果没有第二步 直接返回token 有第二步返回加密手机号
  static Login(data: LoginParams) {
    return httpRequest<LoginResult>({
      url: `${this._baseUrl}/LoginUserExamer/Login`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }
  static UserLoginStepSecond(data: LoginStepSecondParams) {
    return httpRequest<string>({
      url: `${this._baseUrl}/LoginUserExamer/UserLoginStepSecond`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }

  //  根据当前的Token，获取当前登陆的注册用户
  static async GetCurrentRegisterUser() {
    const currentRegisterUser = await httpRequest<CurrentRegisterUserModel>({
      url: `${import.meta.env.VITE_OIDC_AUTHORITY}/connect/userinfo`, 
      method: RequestEnum.GET,
    });
    store.commit("SET_DATA", { name: "currentRegisterUser", data: currentRegisterUser });
    return currentRegisterUser;
  }
}

// 随机验证码服务
export class RandomVerificationCodeClass {
  private static _baseUrl = ServiceGateWay.ZhuoFan_Wb_OAuthService_WebApi + "/api/RandomVerificationCodeService";
  // 获取验证码图片
  static GetRandomVerificationCode(randomMark: string) {
    return httpRequest<string>({
      url: `${this._baseUrl}/RandomVerificationCode/${randomMark}`,
      method: RequestEnum.GET,
    });
  }

  // 获取随机码图片和较验Md5密文
  static GetRandomVerificationCodeMd5(randomMark: string) {
    return httpRequest<RandomVerificationCodeMd5>({
      url: `${this._baseUrl}/RandomVerification/${randomMark}`,
      method: RequestEnum.GET,
    });
  }
}

// 注册用户服务
export class RegisteredUserExamerClass {
  private static _baseUrl = ServiceGateWay.ZhuoFan_Wb_OAuthService_WebApi + "/api/RegisteredUserExamer";

  static RegisterUser(data: RegisterUserParams) {
    return httpRequest<string>({
      url: `${this._baseUrl}/RegisterUser`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }

  // 实名认证并完成注册
  static RealNameAuthentication(registerCode: string, data: RealNameAuthenticationParams) {
    return httpRequest<RealNameAuthenticationResponse>({
      url: `${this._baseUrl}/RealNameAuthentication/${registerCode}`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }

  // 完善实名认证-提升实名认证等级
  static CompleteRealNameAuthentication(data: CompleteRealNameAuthenticationParams) {
    return httpRequest<CompleteRealNameAuthenticationResult>({
      url: `${this._baseUrl}/RealNameAuthentication`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }

  // 完善实名照片
  static CompleteRealNameFaceImage(data: CompleteRealNameFaceImageParams) {
    return httpRequest<undefined>({
      url: `${this._baseUrl}/RealNameFaceImage`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }

  // 发送验证码
  static SendPhoneCode(data: SendPhoneCodeParams) {
    return httpRequest<Boolean>({
      url: `${this._baseUrl}/SendPhoneCode`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }

  // 对比实名认证照片
  static CheckFaceFeature(data: CheckFaceFeatureParams) {
    return httpRequest<number>({
      url: `${this._baseUrl}/CheckFaceFeature`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }
}

export class RegisteredUser {
  private static _baseUrl = ServiceGateWay.ZhuoFan_Wb_OAuthService_WebApi + "/api/wb_management/RegisteredUser";
  // 获取注册用户列表
  static GetRegisteredUserList(params: any) {
    return httpRequest<any>({
      url: `${this._baseUrl}`,
      method: RequestEnum.GET,
      params,
    });
  }
  // 获取单个注册用户
  static GetRegisteredUserInfo(id: string) {
    return httpRequest<any>({
      url: `${this._baseUrl}/${id}`,
      method: RequestEnum.GET,
    });
  }
  // 新增注册用户
  static addRegister(data) {
    return httpRequest<string>({
      url: `${this._baseUrl}/Register`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }
  // 修改实名信息
  static editReal(data) {
    return httpRequest<string>({
      url: `${this._baseUrl}/CertificationInfo`,
      method: RequestEnum.PATCH,
      data,
      options: {
        noTransform: true,
      },
    });
  }
  // 修改状态
  static setState(data) {
    return httpRequest<string>({
      url: `${this._baseUrl}/StateList`,
      method: RequestEnum.PATCH,
      data,
      options: {
        noTransform: true,
      },
    });
  }
  // 重置密码
  static resetPassword(data) {
    return httpRequest<string>({
      url: `${this._baseUrl}/ResetPasswordList/resetPassword`,
      method: RequestEnum.PATCH,
      data,
      options: {
        noTransform: true,
      },
    });
  }
  // 修改手机号
  static updatePhoneNumber(data) {
    return httpRequest<string>({
      url: `${this._baseUrl}/UserContactNumber`,
      method: RequestEnum.PATCH,
      data,
      options: {
        noTransform: true,
      },
    });
  }
  // 删除注册用户
  static RegisterUser(ids: string[]) {
    return httpRequest<any>({
      url: `${this._baseUrl}/Register`,
      method: RequestEnum.DELETE,
      data: ids,
      options: {
        noTransform: true,
      },
    });
  }

  // 图片搜索
  static SearchUserByImage(data) {
    return httpRequest<string>({
      url: `${this._baseUrl}/SearchUserByImage`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }
}

export class RegisterUserScanCodeClass {
  private static _baseUrl = ServiceGateWay.ZhuoFan_Wb_OAuthService_WebApi + "/api/RegisterUserScanCode";

  // 获取二维码地址
  static GetFaceFeatureUrl(HubId: string, TimeStamp: string, UseType: number, Code: string) {
    return httpRequest<string>({
      url: `${this._baseUrl}/FaceFeatureUrl?HubId=${HubId}&TimeStamp=${TimeStamp}&UseType=${UseType}&Code=${Code}`,
      method: RequestEnum.GET,
    });
  }

  // 设置二维码过期
  static SetCodeExpires(HubId: string, TimeStamp: string) {
    return httpRequest<unknown>({
      url: `${this._baseUrl}/SetCodeExpires`,
      method: RequestEnum.POST,
      data: { HubId, TimeStamp },
      options: {
        noTransform: true,
      },
    });
  }

  // 正在扫码
  static ScanCodeRestr(data: GetFaceFeatureUrlParams) {
    return httpRequest<string>({
      url: `${this._baseUrl}/ScanCodeRestr`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }

  // 扫码返回
  static RealPersonAuthentication(data: any) {
    return httpRequest<string>({
      url: `${this._baseUrl}/RealPersonAuthentication`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }

  // 人脸识别找回密码
  static ScanCodeRecovery(data: any) {
    return httpRequest<string>({
      url: `${this._baseUrl}/ScanCodeRecovery`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }
}

export class RecoverUserExamer {
  private static _baseUrl = ServiceGateWay.ZhuoFan_Wb_OAuthService_WebApi + "/api/RecoverUserExamer";
  // 找回密码第一步
  static PasswordRecoverStepOne(data) {
    return httpRequest<any>({
      url: `${this._baseUrl}/PasswordRecoverStepOne`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }
  // 手机验证码找回第二步
  static PhoneRecoverStepSecond(data) {
    return httpRequest<any>({
      url: `${this._baseUrl}/PhoneRecoverStepSecond`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }
  // 找回密码第三步
  static PhoneRecoverStepThird(data) {
    return httpRequest<any>({
      url: `${this._baseUrl}/PhoneRecoverStepThird`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }

  // 换绑手机第一步
  static recoverPhoneByCodeStepOne(data: any) {
    return httpRequest({
      url: `${this._baseUrl}/RecoverPhoneByCodeStepOne`,
      method: RequestEnum.POST,
      data,
      options: {
        noTransform: true,
      },
    });
  }
  // 换绑手机第二步
  static changePhone(data: any) {
    return httpRequest({
      url: `${this._baseUrl}/ChangePhone`,
      method: RequestEnum.PATCH,
      data,
      options: {
        noTransform: true,
      },
    });
  }
}
